import { render, staticRenderFns } from "./personal_data.vue?vue&type=template&id=208a1b1a&"
import script from "./personal_data.vue?vue&type=script&lang=js&"
export * from "./personal_data.vue?vue&type=script&lang=js&"
import style0 from "./personal_data.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports